
            const data = {"name":"check","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.707 6.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L9 15.586l9.293-9.293a1 1 0 0 1 1.414 0Z\" _fill=\"#4CAB26\"/>","originalColors":[{"type":"fill","color":"#4CAB26"}],"stopColors":[]}}
        
                    module.exports = data
                    